<template>
  <div class="container-fluid">
    <div class="page-header">
      <div class="row">
        <div class="col-lg-12 nav-header">
          <div class="page-header-left">
            <h3 >{{title}}</h3>
            <ol class="breadcrumb">
              <li v-if="isAdmin" class="breadcrumb-item"><router-link :to="{ path: '/admin/dashboard' }"><feather type="home"></feather></router-link></li>
              <li v-if="!isAdmin" class="breadcrumb-item"><router-link :to="{ path: '/kunde/dashboard' }"><feather type="home"></feather></router-link></li>
              <li class="breadcrumb-item" v-for="(crumb, index) in breadcrumbs" :key="crumb+'_'+index">{{crumb}}</li>
            </ol>
          </div>
          <!--
          <div class="page-header-right">
            <feather type="chevron-left" size="40" class="infra-blue pointer" @click="$router.go(-1)"></feather>
            <feather type="chevron-right" size="40" class="infra-blue pointer" @click="$router.go(1)"></feather>
          </div>
          -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  props: {
    main: {
      default: ''
    }
  },  
  computed: {
    ...mapGetters({
      bauprojekte: "app/bauprojekte",
      hauser: "app/hauser",
      wohnungen: "app/wohnungen",
      dienstleister: "app/dienstleister",
      kunden: "app/kunden",
      isAdmin: "auth/isAdmin"
    }),
    title: function() {
      return this.$route.meta.title
    },
    breadcrumbs: function() {
      const route = this.$route.fullPath;
      let separated = route.split("/");
      let clean = separated.filter((chunk) => {
        if ( chunk !== "admin" && chunk !== "" && chunk !== "dashboard") return chunk
      });
      
      //transform digits to name of item
      let indexBp = clean.indexOf("bauprojekte");
      let indexHaus = clean.indexOf("haus");
      let indexWoh = clean.indexOf("wohnung");
      let indexDl = clean.indexOf("dienstleister"); 
      let indexKu = clean.indexOf("kunde");


      if( indexBp > -1 && "undefined" !== typeof(clean[indexBp +1]) && !isNaN(clean[indexBp +1])) {
        const foundBp = this.bauprojekte.find(bp => clean[indexBp + 1] == bp.id);
        clean[indexBp +1] = foundBp.name;
      }

      if( indexHaus > -1 && "undefined" !== typeof(clean[indexHaus +1]) && !isNaN(clean[indexHaus +1])) {
        const foundHaus = this.hauser.find(haus => clean[indexHaus + 1] == haus.id);
        clean[indexHaus + 1] = foundHaus.name;
      }

      if( indexWoh > -1 && "undefined" !== typeof(clean[indexWoh +1]) && !isNaN(clean[indexWoh + 1]))  {
        const foundWoh = this.wohnungen.find(woh => clean[indexWoh + 1] == woh.id);
        clean[indexWoh +1] = foundWoh.name;
      }

      if(indexDl > -1 && "undefined" !== typeof(clean[indexDl +1]) && !isNaN(clean[indexDl + 1])) {
        const foundDl = this.dienstleister.find(dl => clean[indexDl +1] == dl.id);
        clean[indexDl +1] = foundDl.name;
      }

      if(indexKu > -1 && "undefined" !== typeof(clean[indexKu +1]) && !isNaN(clean[indexKu+1])) {
        const foundKu = this.kunden.find(dl => clean[indexKu+1] == dl.id);
        clean[indexKu + 1] = foundKu.first_name + " " + foundKu.last_name;
      }  


      let streamline = clean.map( (chunk) => {
        if(chunk.indexOf("-") > -1 ) {
          let split = chunk.split("-");
          let ucFirst = split.map(chunky => {
            return chunky.charAt(0).toUpperCase() + chunky.slice(1);
          });
          return ucFirst.join("-");
        } else {
        return chunk.charAt(0).toUpperCase() + chunk.slice(1);
        }
      });     

      return streamline;
    }
  },
  methods: {

  }
}
</script>


<style>
.page-header-left,
.page-header-right {
  display:inline-flex!important;
}

.nav-header {
  display:flex;
  justify-content:space-between;
}
</style>
